import type { PageContext } from '@zto/zpage'

import { SysConfigPaths, SysConfigStatus, commonOptions, SysConfigMetaType, DialogType } from '@/config'
import { addEditDialog } from './_addEdit'

/** 返回增删改查配置 */
export function crud() {
  return {
    type: 'crud',

    actions: {
      query: {
        api: '/sys/admin/config/node/list',
        apiParams: {
          parentNodePath: SysConfigPaths.TDL,
          pageSize: 200
        }
      },
      add: {
        api: '/sys/admin/config/node/create',
        dialog: addEditDialog(DialogType.ADD)
      },
      edit: {
        api: '/sys/admin/config/node/update',
        dialog: addEditDialog(DialogType.EDIT)
      },
      enable: {
        api: '/sys/admin/config/node/changeStatus',
        payload: {
          nodeId: '${data.row.nodeId}',
          status: SysConfigStatus.ENABLE
        }
      },
      disable: {
        api: '/sys/admin/config/node/changeStatus',
        payload: {
          nodeId: '${data.row.nodeId}',
          status: SysConfigStatus.DISABLE
        }
      },
      delete: {
        api: '/sys/admin/config/node/delete',
        payload: {
          nodeId: '${data.row.nodeId}'
        }
      }
    },

    search: () => {
      const formItems: any[] = [{ type: 'input', prop: 'code', label: '编号', span: 6 }]

      return {
        items: formItems
      }
    },

    toolbar: {},

    table: {
      noPager: true,
      noIndex: true,
      tree: {
        parentProp: 'parentNodeId',
        rowKey: 'nodeId'
      },
      operation: {
        position: 'right',
        width: 150,
        items: [
          { action: 'add', visibleOn: `!this.data.row.leaf` },
          { action: 'edit', visibleOn: `!this.data.row.readonly` },
          {
            action: 'enable',
            visibleOn: `!this.data.row.readonly && (this.data.row.status == ${SysConfigStatus.DISABLE} || this.data.row.status == ${SysConfigStatus.NEW})`
          },
          {
            action: 'disable',
            visibleOn: `!this.data.row.readonly && this.data.row.status == ${SysConfigStatus.ENABLE}`
          },
          {
            action: 'delete',
            visibleOn: `!this.data.row.readonly && !this.data.row.hasChildren && (this.data.row.status == ${SysConfigStatus.DISABLE} || this.data.row.status == ${SysConfigStatus.NEW})`
          }
          // { action: 'log', label: '日志' }
        ]
      },
      columns: [
        { label: '名称', prop: 'name', tpl: '${data.row.sn} ${data.row.name}', width: 200, expandColumn: true },
        { label: '编号', prop: 'code', width: 150 },
        { label: '排序号', prop: 'sort', width: 80 },
        {
          label: '状态',
          prop: 'status',
          formatter: { name: 'enumStr', options: commonOptions.sysConfigStatus },
          width: 80
        },
        { label: '备注', prop: 'remark', minWidth: 200 },
        { label: '创建人', prop: 'creator', width: 100 },
        { label: '创建时间', prop: 'gmtCreate', width: 150 },
        { label: '修改人', prop: 'modifier', width: 100 },
        { label: '修改时间', prop: 'gmtModified', width: 150 }
      ]
    }
  }
}
